module.exports = __webpack_public_path__ + "static/img/find_team_icon.6a31444.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/sixthAnniveRecall/recall/find_team_icon.png
// module id = S6Ad
// module chunks = 1